import { render, staticRenderFns } from "./sales-exclusive.vue?vue&type=template&id=36a8aec6"
import script from "./sales-exclusive.vue?vue&type=script&lang=js"
export * from "./sales-exclusive.vue?vue&type=script&lang=js"
import style0 from "./sales-exclusive.vue?vue&type=style&index=0&id=36a8aec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports